import { render, staticRenderFns } from "./scanCodePage.vue?vue&type=template&id=b4cbc7bc&scoped=true"
import script from "./scanCodePage.vue?vue&type=script&lang=js"
export * from "./scanCodePage.vue?vue&type=script&lang=js"
import style0 from "./scanCodePage.vue?vue&type=style&index=0&id=b4cbc7bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cbc7bc",
  null
  
)

export default component.exports